<template>
  <div class="profile-body">
    <div class="field">
      <div class="field__label">🪐 출신행성</div>
      <v-select
        :value="myVirtupetProfile.planet"
        @change="onPlanetChange"
        :items="planets"
        hide-details
        dense
        outlined
      ></v-select>
    </div>

    <div class="field">
      <div class="field__label">🔢 나이</div>
      <div class="d-flex align-center">
        <span class="field__value">{{ myVirtupetProfile.age | defaultValue }}</span>
        <v-spacer></v-spacer>
        <v-btn small text @click="onClickRandomAge">🎲 랜덤</v-btn>
      </div>
    </div>

    <div class="field">
      <div class="field__label">🧚 성별</div>
      <v-select
        :value="myVirtupetProfile.gender"
        :items="genders"
        @change="onGenderChange"
        hide-details
        dense
        outlined
      ></v-select>
    </div>

    <div class="field">
      <div class="field__label">🧑‍🚀 직업</div>
      <v-select
        :value="myVirtupetProfile.job"
        :items="jobs"
        @change="onJobChange"
        hide-details
        dense
        outlined
      ></v-select>
    </div>

    <div class="field">
      <div class="field__label">🕵️ MBTI</div>
      <v-select
        :value="myVirtupetProfile.mbti"
        :items="mbtis"
        @change="onMbtiChange"
        hide-details
        dense
        outlined
      ></v-select>
    </div>

    <div class="meet-days">
      <span style="font-weight: 900">{{ myVirtupetProfile.name }}</span
      >을 만난지 <span style="font-weight: 900">+{{ myUserProfile.createdAt | fromNowDays }}일째</span> 되는 날입니다
    </div>
  </div>
</template>

<script>
import moment from "moment";
import SupabaseApi from "../../../api/SupabaseApi";

export default {
  filters: {
    fromNowDays(value) {
      return moment().diff(moment(value), "days");
    },
  },
  async created() {
    const { level } = (await SupabaseApi.fetchMyVirtupetLevelMeta()) || {};
    this.level = level;

    this.myUserProfile = (await SupabaseApi.fetchMyProfile()) || {};
    this.myVirtupetProfile = (await SupabaseApi.PetProfile.fetchProfile()) || {};
    this.$emit("change", this.myVirtupetProfile);
  },
  data() {
    return {
      level: null,
      myUserProfile: {}, // streamer_account
      myVirtupetProfile: {
        name: null,
        planet: null,
      },

      planets: [
        "수성 (Mercury)",
        "금성 (Venus)",
        "지구 (Earth)",
        "화성 (Mars)",
        "목성 (Jupiter)",
        "토성 (Saturn)",
        "천왕성 (Uranus)",
        "해왕성 (Neptune)",
      ],
      genders: ["남성", "여성", "중성"],
      jobs: [
        "농부",
        "목수",
        "광부",
        "사냥꾼",
        "요리사",
        "의사",
        "교사",
        "연구원",
        "기술자",
        "예술가",
        "연예인",
        "운동선수",
      ],
      mbtis: [
        "ISTJ",
        "ISFJ",
        "INFJ",
        "INTJ",
        "ISTP",
        "ISFP",
        "INFP",
        "INTP",
        "ESTP",
        "ESFP",
        "ENFP",
        "ENTP",
        "ESTJ",
        "ESFJ",
        "ENFJ",
        "ENTJ",
      ],
    };
  },
  methods: {
    async onNameChange(value) {
      this.myVirtupetProfile.name = value;
      this.$store.commit("__setVirtupetName", value);
      await this.onSaveVirtupetProfile();
    },
    async onPlanetChange(value) {
      this.myVirtupetProfile.planet = value;
      await this.onSaveVirtupetProfile();
    },
    async onClickRandomAge() {
      this.myVirtupetProfile.age = Math.floor(Math.random() * 100);
      await this.onSaveVirtupetProfile();
    },
    async onGenderChange(value) {
      this.myVirtupetProfile.gender = value;
      await this.onSaveVirtupetProfile();
    },
    async onJobChange(value) {
      this.myVirtupetProfile.job = value;
      await this.onSaveVirtupetProfile();
    },
    async onMbtiChange(value) {
      this.myVirtupetProfile.mbti = value;
      await this.onSaveVirtupetProfile();
    },
    //

    //
    async onSaveVirtupetProfile() {
      await SupabaseApi.PetProfile.updateProfile(this.myVirtupetProfile);
      this.$emit("change", this.myVirtupetProfile);
    },
    async onClickTest() {
      await SupabaseApi.upsertVirtupetLevel(1, 100, 1000);
    },
  },
};
</script>

<style scoped>
.profile-card {
  border-radius: 16px;
}
.field {
  margin-bottom: 12px;
}
.field__label {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 4px;
}
.field__value {
  font-size: 15px;
  font-weight: 700;
}
.meet-days {
  margin-top: 8px;
  font-size: 13px;
  color: var(--v-sidebarText-base, #6b6680);
}
</style>
